module.exports = __webpack_public_path__ + "static/media/dollar-sign.8a509ad3.svg";